export function redirectToSsoRetryUrl(portalUrl: string, retryUrl: string, organizationName: string) {
    const decodedRetryUrl = decodeURIComponent(retryUrl);
    const encodedAcrValue = encodeURIComponent(`tenantName:${organizationName}`);
    const url = `${portalUrl}${decodedRetryUrl}${decodedRetryUrl.indexOf('?') > 0 ? '&' : '?'}acr_values=${encodedAcrValue}`;
    window.location.assign(url);
}
